export default __webpack_public_path__ + "static/media/pharmatching-news.bec28103.png";